import type { GuidebookProperty } from "./types"

interface Props {
  property: GuidebookProperty
  /** Voice-aware section heading. Falls back to "Need help?". */
  sectionTitle?: string
  /** Voice-aware body text. Falls back to default. */
  bodyText?: string
}

export function EmergencySection({ property, sectionTitle, bodyText }: Props) {
  return (
    <div className="gb-section">
      <h2 className="gb-section__title">{sectionTitle || "Need help?"}</h2>
      <div className="gb-card">
        <div className="gb-emergency__body">
          {property.address && (
            <p>
              The property is located at{" "}
              <span className="gb-emergency__address">{property.address}</span>.
            </p>
          )}
          <p>
            {bodyText || "We\u2019re always here for you. For anything at all, reach out directly to your host."}
          </p>
        </div>
      </div>
    </div>
  )
}
